export const remCalc = (px: string, base = 16): string => {
  const tempPx = px.replace('px', '');
  return (1 / base) * parseInt(tempPx) + 'rem';
};

export const colors = {
  blue: '#1E325A',
  tan: '#D2B48C',
  black: '#181818',
};

// Échelle typographique basée sur le nombre d'or (φ ≈ 1.618)
// 10 → 16 → 26 → 42 → 68  (chaque valeur × φ ≈ la suivante)
export const fontSize = {
  mini: remCalc('10px'), // icônes, labels discrets
  small: remCalc('16px'), // corps de texte (base)
  medium: remCalc('26px'), // sous-titres, menu  (16 × φ)
  smallTitle: remCalc('42px'), // titres secondaires (26 × φ)
  title: remCalc('68px'), // titre principal    (42 × φ)
};

export const fontFamily = {
  tinos: 'Tinos, serif',
  playfair: 'Playfair Display, serif',
};

// Espacement basé sur la suite de Fibonacci (liée au nombre d'or)
// 5 → 8 → 13 → 21 → 34 → 55
export const spacing = {
  xs: '5px',
  sm: '8px',
  md: '13px',
  lg: '21px',
  xl: '34px',
  xxl: '55px',
};

export const borderRadius = {
  sm: '4px',
  md: '8px',
  lg: '10px',
};

export const zIndex = {
  behind: -100,
  overlay: 2,
  controls: 3,
};

export const transitions = {
  fast: '0.3s ease',
  slow: '1s ease-in-out',
};
